import { Component, Input, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { ConfirmarDialogComponent } from '../confirmar-dialog/confirmar-dialog.component';
import { Router } from '@angular/router';

@Component({
  selector: 'collapsible-component',
  templateUrl: './collapsible.component.html',
  styleUrls: ['./collapsible.component.scss']
})
export class CollapsibleComponent implements OnInit {
  @ViewChild('body', { static: true }) body: ElementRef;

  private readonly EXPAND_MORE_ICON: string = 'expand_more';
  private readonly EXPAND_LESS_ICON: string = 'expand_less';
  private readonly ARROW_FORWARD_ICON: string = 'arrow_forward';

  @Input() image: string;
  @Input() title: string;
  @Input() imgWidth: string;
  @Input() collapsible: boolean = true;
  @Input() disabled: boolean;
  @Input() disabledTitle: string = '';
  @Input() disabledText: string = '';
  @Input() disabledRoute: string = '';

  @Output() clickComponentEventHandler: EventEmitter<void>;

  indicatorIcon: string;

  expand: boolean = false;

  private contentHeight: string;

  get height(): string {
    return this.body.nativeElement.offsetHeight;
  }

  set height(value: string) {
    // this.body.nativeElement.style.height = `${value}px`;
    this.body.nativeElement.style.height = value;
  }

  constructor(private dialog: MatDialog, private router: Router) {
    this.clickComponentEventHandler = new EventEmitter();
  }

  ngOnInit() {
    this.indicatorIcon = this.collapsible ? this.EXPAND_MORE_ICON : this.ARROW_FORWARD_ICON;
    this.contentHeight = this.height;
    this.height = '0';
  }

  toggleEventHandler() {
    if (!this.disabled) {
      this.expand = !this.expand;
      this.indicatorIcon = this.expand ? this.EXPAND_LESS_ICON : this.EXPAND_MORE_ICON;
      this.height = this.expand ? 'unset' : '0px';
    } else {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        id: 1,
        title: this.disabledTitle,
        info: this.disabledText
      };
      dialogConfig.width = '400px';

      const dialogRef = this.dialog.open(ConfirmarDialogComponent, dialogConfig);
      dialogRef.afterClosed().subscribe((data) => {
        if (data) {
          this.router.navigate([this.disabledRoute]);
        }
      });
    }
  }

  clickEventHandler(): void {
    if (this.collapsible) {
      this.toggleEventHandler();
    } else {
      this.clickComponentEventHandler.emit();
    }
  }
}
